import { useState } from "react";
import { api, formatApiError } from "@/lib/api";

const inputCls = "w-full border border-[#CFCFCB] bg-white px-3 py-2.5 font-ui text-sm outline-none focus:border-[var(--ink)] transition-colors";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "", website: "" });
  const [state, setState] = useState({ status: "idle" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setState({ status: "busy" });
    try {
      await api.post("/contact", form);
      setState({ status: "sent" });
    } catch (err) {
      setState({ status: "error", error: formatApiError(err) });
    }
  };

  return (
    <div className="max-w-2xl mx-auto pt-14 fade-up" data-testid="contact-page">
      <p className="meta">Contact</p>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">Write to ukdiscovered.</h1>
      <p className="mt-6 text-lg text-[var(--ink-2)] leading-relaxed">
        Have a story that deserves to be told properly, a correction, or something to say about a piece? Your message comes straight to the author and is kept private.
      </p>
      {state.status === "sent" ? (
        <div className="mt-10 border-l-2 border-[var(--ink)] pl-5" data-testid="contact-success">
          <p className="font-display text-2xl font-semibold">Thank you — your message has been received.</p>
          <p className="mt-2 text-[var(--ink-2)]">If you've asked for a reply, you'll hear back by email.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 grid gap-5" data-testid="contact-form">
          <div className="grid gap-5 sm:grid-cols-2">
            <label className="grid gap-2"><span className="meta !text-[var(--ink-2)]">Name</span>
              <input required maxLength={120} value={form.name} onChange={set("name")} className={inputCls} data-testid="contact-name-input" /></label>
            <label className="grid gap-2"><span className="meta !text-[var(--ink-2)]">Email</span>
              <input required type="email" value={form.email} onChange={set("email")} className={inputCls} data-testid="contact-email-input" /></label>
          </div>
          <label className="grid gap-2"><span className="meta !text-[var(--ink-2)]">Message</span>
            <textarea required rows={8} maxLength={5000} value={form.message} onChange={set("message")} className={`${inputCls} font-body text-base leading-relaxed`} data-testid="contact-message-input" /></label>
          <input tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} className="hidden" aria-hidden="true" />
          {state.status === "error" && <p className="font-ui text-sm text-[var(--accent)]" data-testid="contact-error">{state.error}</p>}
          <div>
            <button type="submit" disabled={state.status === "busy"} className="font-ui text-sm px-6 py-3 bg-[var(--ink)] text-white hover:bg-[var(--accent)] transition-colors disabled:opacity-60" data-testid="contact-submit-button">
              {state.status === "busy" ? "Sending…" : "Send message"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
